<template>
  <div id="app" :class="{ minWidth: !$route.meta.isPhonePage }">
    <div class="wrapper" v-if="$route.meta.rv === 1">
      <!-- TopBar -->
      <CTopBar></CTopBar>
      <div class="appContent">
        <!-- 默认侧边导航栏 -->
        <CNavBar v-if="!$route.meta.isMap"></CNavBar>
        <!-- 平台右边区域 -->
        <div class="rightArea">
          <!-- 主内容区 -->
          <router-view v-if="isRouterAlive"></router-view>
        </div>
      </div>
    </div>

    <!-- 体验版页面 -->
    <div class="wrapper" v-if="$route.meta.rv === 2">
      <!-- TopBar -->
      <ExpCTopBar></ExpCTopBar>
      <div class="appContent">
        <!-- 默认侧边导航栏 -->
        <ExpCNavBar></ExpCNavBar>
        <!-- 平台右边区域 -->
        <div class="rightArea">
          <!-- 主内容区 -->

          <router-view></router-view>
        </div>
      </div>
    </div>

    <!-- 登录(包括体验版)页面、仪表盘页、手机端、数据看板页 -->
    <router-view v-if="$route.meta.rv === 0"></router-view>
  </div>
</template>

<script>
import CNavBar from "@/components/Page/Layout/CNavBar.vue";
import CTopBar from "@/components/Page/Layout/CTopBar.vue";
import ExpCNavBar from "@/components/ExpPage/Layout/CNavBar.vue";
import ExpCTopBar from "@/components/ExpPage/Layout/CTopBar.vue";
import {
  localUserInfo,
  setLogoTitle,
  showToast
} from "../static/js/utility/utility.js";
let vm;

export default {
  name: "App",
  components: {
    CNavBar,
    CTopBar,
    ExpCNavBar,
    ExpCTopBar
  },

  provide() {
    return {
      reload: this.reload
    };
  },

  data() {
    return {
      isRouterAlive: true
    };
  },

  created() {
    vm = this;
    // console.log('APP---route', vm.$route)
    // console.log('window.location.href', window.location.origin)
    // 当前访问服务器信息
    vm.getCurrentServerInfo();
    // 当本地存储的userInfo存在，赋值给vuex，供页面调用
    if (localUserInfo.getItem()) {
      vm.$store.state.eUserInfo = localUserInfo.getItem();
    }

  },

  mounted() {
    setLogoTitle();
  },

  computed: {},
  methods: {
    // 获取当前访问服务器信息(isSCM：true为供应链，false为智慧空间)-登陆页切换空间/供应链
    getCurrentServerInfo() {
      let info = {};

      switch (window.location.origin) {
        // 本地测试
        case "http://localhost:81":
          info =
            // {
            //   isSCM: true,
            //   type: 'localCS',
            //   name: '本地测试-极酷',
            //   title: 'CPS云物联平台',
            //   logoUrl: '/static/images/logo/logo_geeku.png',
            //   logoUrl2: '/static/images/logo/logo_geeku_white.png'
            // }
            // {
            // 	isSCM: false,
            // 	type: 'bohe',
            // 	name: '本地测试-薄荷空间',
            // 	title: '智慧空间管理平台',
            // 	logoUrl: '/static/images/logo/logo_bohe.png',
            // 	logoUrl2: '/static/images/logo/logo_bohe_white.png'
            // }
            {
              isSCM: false,
              type: "shantou",
              name: "汕头移动",
              title: "智慧空间管理平台",
              comInfo01: "©Copyright",
              comInfo02: "广州薄荷空间科技有限公司",
              comInfo03: "www.mintspace.cn",
              logoUrl: "/static/images/logo/logo_yd.png",
              logoUrl2: "/static/images/logo/logo_yd.png"
            };
          break;
        // 供应链
        case "http://enterprise_platform4-dev.geekuiot.com": // 极酷开发环境
        case "http://enterprise_platform4.geekuiot.com": // 极酷测试环境
        case "http://enterprise-platform4.geekuiot.com": // 极酷测试环境
        case "http://v4.geeku.top": // 极酷正式环境
          info = {
            isSCM: true,
            type: "geeku",
            title: "CPS云物联平台",
            comInfo01: "©Copyright",
            comInfo02: "广州极酷物联智能科技有限公司",
            comInfo03: "www.geeku.top",
            logoUrl: "/static/images/logo/logo_geeku.png",
            logoUrl2: "/static/images/logo/logo_geeku_white.png"
          };
          break;
        case "http://192.168.8.204:82":
          info = {
            isSCM: true,
            name: "绿廋",
            type: "lvshou",
            title: "CPS云物联平台",
            logoUrl: "/static/images/logo/logo_lvshou.jpg",
            logoUrl2: "/static/images/logo/logo_lvshou.jpg"
          };
          break;
        // 空间
        case "http://v4-dev.mintspace.cn": // 薄荷空间-开发环境
        case "http://v4-test.mintspace.cn": //薄荷空间-测试环境
        case "http://v4.mintspace.cn": // 薄荷空间-正式环境
          info = {
            isSCM: false,
            type: "bohe",
            title: "智慧空间管理平台",
            logoUrl: "/static/images/logo/logo_bohe.png",
            logoUrl2: "/static/images/logo/logo_bohe.png"
          };
          break;
        case "http://cmccshantou-enterprise.geekuiot.com": // 汕头移动-正式环境
        case "http://36.133.31.159:8082": // 阳江移动-正式环境
          info = {
            isSCM: false,
            name: "汕头移动",
            type: "shantou",
            title: "智慧空间管理平台",
            logoUrl: "/static/images/logo/logo_yd.png",
            logoUrl2: "/static/images/logo/logo_yd.png"
          };
          break;
        default:
          info = {
            isSCM: true,
            type: "geeku",
            title: "CPS云物联平台",
            logoUrl: "/static/images/logo/logo_geeku.png",
            logoUrl2: "/static/images/logo/logo_geeku_white.png"
          };
      }
      vm.$store.state.currentServerInfo = process.env.APP_INFO;
    },

    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },

  },
  watch: {
    "$route.path"(newVal, oldVal) {
      if (oldVal === "/Dkb") {
        setLogoTitle();
      }
    }
  }
};
</script>

<style lang="scss">
#app {
  // overflow: hidden;
  &.minWidth {
    min-width: 1300px;
  }
  .wrapper {
    width: 100%;
    height: 100vh;
    // overflow: hidden;
    background: #00589b;
    display: flex;
    flex-direction: column;
    .appContent {
      height: calc(100vh - 90px);
      display: flex;
    }
  }
  .CTopBar {
    flex-shrink: 0;
  }
  .rightArea {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    .mainArea {
      padding-bottom: 24px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue